// src/lib/ga.js
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_CODE;

// gtag 薄いラッパ（純JS）
export const gtag = (...args) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...args);
  }
};

// ページビュー送信
export const gaPageView = (path, title) => {
  if (!GA_MEASUREMENT_ID) return;
  gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};

// 任意イベント
export const gaEvent = (name, params = {}) => {
  if (!GA_MEASUREMENT_ID) return;
  gtag("event", name, params);
};

// 初回UTMをセッション保存
export const persistInitialUtm = () => {
  const KEY = "nl_first_utm";
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem(KEY)) return;

  const p = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  const utm = {};
  keys.forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  if (Object.keys(utm).length) {
    sessionStorage.setItem(KEY, JSON.stringify(utm));
  }
};

// 初回UTMの取得
export const getInitialUtm = () => {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(sessionStorage.getItem("nl_first_utm") || "{}");
  } catch {
    return {};
  }
};
